module.exports = __webpack_public_path__ + "img/7.178fc867.png";